const DEFAULT_TITLE = 'ISK | Property Management';

export function removeEmergentBranding() {
  if (/emergent/i.test(document.title)) {
    document.title = DEFAULT_TITLE;
  }

  document.getElementById('emergent-badge')?.remove();

  document.querySelectorAll('a[href*="emergent"], [id*="emergent"]').forEach((element) => {
    if (/emergent/i.test(element.id || '') || /emergent/i.test(element.href || '')) {
      element.remove();
    }
  });

  document.querySelectorAll('script[src*="emergent"]').forEach((script) => script.remove());
}
